import Clipboard from 'clipboard'
import { debug } from '../modules/util'

const name = 'Clipboard'

function init () {
  debug(`${name}: init()`)

  const clipboard = new Clipboard('.clipboard')
  clipboard.on('success', handleSuccess)
  clipboard.on('error', handleError)
}

function handleSuccess (e) {
  debug(`${name} Action:`, e.action)
  debug(`${name} Text:`, e.text)
  debug(`${name} Trigger:`, e.trigger)

  e.trigger.classList.add('is-success')
  setTimeout(() => {
    e.trigger.classList.remove('is-success')
    e.clearSelection()
  }, 2000)
}

function handleError (e) {
  console.error(`${name} Action:`, e.action)
  console.error(`${name} Trigger:`, e.trigger)
}

export default { init }